<template lang="pug">
  .container-group-view(ref="container")
    .top-row
      .tr-element {{ $t('Screen Group View')}}:
      .tr-element.group-name(v-if="desktopGroup") &nbsp; {{ desktopGroup.name }}
      .tr-element &nbsp; {{ $t('at') }} &nbsp;
      el-date-picker(v-model='timestampForTree', type='datetime', size='mini', :placeholder="$t('Select date and time')")
      .tr-element.day-of-week &nbsp; {{ $t($moment(timestampForTree).format('dddd')) }}
      .tr-element &nbsp;
      el-button-group
        el-button(
          size='mini',
          :type='playbackMode === "backward" ? "success" : "default"',
          @click='setPlaybackMode("backward")',
          title='10x'
        )
          font-awesome-icon(icon="backward")
        el-button(
          size='mini',
          :type='playbackMode === "play-reverse" ? "success" : "default"',
          @click='setPlaybackMode("play-reverse")'
        )
          font-awesome-icon.flip-horizontal(icon="play")
        el-button(
          size='mini',
          :type='playbackMode === "stop" ? "success" : "default"',
          @click='setPlaybackMode("stop")'
        )
          font-awesome-icon(icon="stop")
        el-button(
          size='mini',
          :type='playbackMode === "play" ? "success" : "default"',
          @click='setPlaybackMode("play")'
        )
          font-awesome-icon(icon="play")
        el-button(
          size='mini',
          :type='playbackMode === "forward" ? "success" : "default"',
          @click='setPlaybackMode("forward")',
          title='10x'
        )
          font-awesome-icon(icon="forward")
      el-input-number(size='mini', v-model='timeStepMinutes', :step='5')
      .tr-element &nbsp; {{ $t('step in minutes')}}
      .progres-container.float-right(v-if='progresVisible')
        .progres.float-left
      hr.header
    .desktops-loading(v-if='isLoading')
      span {{ $t('loading...') }}
    .desktops(v-if='!isLoading')
      .desktop(
        v-for='desktop in desktops', :key='desktop.id', :id="'desktop-column'+desktop.id",
        :style="`width:${containerWidth / desktops.length - 66/ desktops.length}px`",
      )
        .name {{ getFullDeviceNameByDesktopId(desktop.id) }}
        .screenshot(
            :id="'DeviceList-desktopThumbnail'+desktop.id",
            @click.stop='showScreenShot(desktop)',
            :title="desktop.deviceDesktopScreenShotFilename ? $t('Screenshot') : $t('No screenshot yet')"
          )
          img(v-if='desktop.deviceDesktopScreenShotFilename', :src='desktop.deviceDesktopScreenShotFilename', :style="`width:${containerWidth / desktops.length - 66 / desktops.length - 2}px`")
        .playlistTree
          PlayListTree(:playListTree='desktop.playListTree', :timestampForTree='timestampForTree', :treeViewParams='treeViewParams')
</template>

<script>
import Vue from 'vue'
import PlayListTree from '../Medium/PlayListTree'
import mediaUtils from '../Common/mediaUtils.mixin'
import deviceUtils from '../Common/deviceUtils.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [mediaUtils, deviceUtils, textUtils],
  components: {
    PlayListTree
  },
  props: ['side', 'desktopGroup'],
  data () {
    return {
      errors: {
      },
      desktops: [],
      containerWidth: 0,
      desktopGroupEditorVisible: false,
      isSaving: false,
      isLoading: false,
      timestampForTree: new Date(),
      treeViewParams: {
        showThumbs: {
          value: true,
          icon: 'image',
          titleActivate: this.$t('show thumbs'),
          titleDeactivate: this.$t('hide thumbs')
        },
        showRestrictions: {
          value: false,
          icon: 'clock',
          titleActivate: this.$t('show restrictions'),
          titleDeactivate: this.$t('hide restrictions')
        },
        showOnlyPlaylists: {
          value: false,
          icon: 'film',
          titleActivate: this.$t('hide non-container media'),
          titleDeactivate: this.$t('show non-container media')
        },
        showIdentation: {
          value: false,
          icon: 'indent',
          titleActivate: this.$t('remove indentation'),
          titleDeactivate: this.$t('indent')
        },
        showOnlyPlayable: {
          value: false,
          icon: 'eye-slash',
          titleActivate: this.$t('hide media not fulfilling restrictions'),
          titleDeactivate: this.$t('show all media regardless of fulfilling restrictions')
        },
        menuBoardMode: {
          value: true,
          icon: 'address-card',
          titleActivate: this.$t('menuboard mode'),
          titleDeactivate: this.$t('disable menuboard mode')
        }
      },
      playbackMode: 'stop',
      playbackInterval: undefined,
      timeStepMinutes: 60,
      timeStep: 60 * 60 * 1000,
      progresVisible: false
    }
  },
  async created () {
    await this.loadData()
    this.containerWidth = this.$refs.container.clientWidth
  },
  async beforeDestroy () {
    clearInterval(this.playbackInterval)
    this.progresVisible = false
    this.timestampForTree = new Date()
  },
  watch: {
    desktopGroup: async function (newVal, oldVal) {
      await this.loadData()
    },
    timeStepMinutes: async function (newVal, oldVal) {
      this.timeStep = this.timeStepMinutes * 60 * 1000
    }
  },
  methods: {
    setPlaybackMode (mode) {
      if (this.playbackMode === mode) mode = 'stop'
      this.playbackMode = mode
      this.progresVisible = false
      Vue.nextTick(() => {
        this.progresVisible = !(mode === 'stop')
      })
      clearInterval(this.playbackInterval)
      this.playbackInterval = setInterval(() => {
        switch (this.playbackMode) {
          case 'stop':
            return
          case 'play':
            this.timestampForTree = new Date(this.timestampForTree.getTime() + this.timeStep)
            break
          case 'play-reverse':
            this.timestampForTree = new Date(this.timestampForTree.getTime() - this.timeStep)
            break
          case 'forward':
            this.timestampForTree = new Date(this.timestampForTree.getTime() + 10 * this.timeStep)
            break
          case 'backward':
            this.timestampForTree = new Date(this.timestampForTree.getTime() - 10 * this.timeStep)
            break
          default:
            break
        }
      }, 1 * 1000)
    },
    closeGroupEditor () {
      this.desktopGroupEditorVisible = false
    },
    async updateGroup () {
      this.isSaving = true
      await Vue.axios.patch(`devicedesktopgroup/${this.desktopGroup.id}`, { name: this.desktopGroup.name })
      this.isSaving = false
      this.desktopGroupEditorVisible = false
    },
    async deleteGroup () {
      await Vue.axios.delete(`devicedesktopgroup/${this.desktopGroup.id}`)
    },
    async loadData () {
      this.isLoading = true
      if (!this.desktopGroup) return
      this.desktops = JSON.parse(JSON.stringify(this.desktopGroup.DeviceDesktops))
      for (const desktop of this.desktops) {
        desktop.playListTree = {}
        desktop.playListTree.PlayItems = (await Vue.axios.post('medium/getPlaylistContentTree', { playListId: desktop.LocalPlayList })).data
        desktop.playListTree.mediumname = ''
        desktop.playListTree.type = 'PlayListDesktop'
        const timeRestrictions = (await Vue.axios.post('deviceDesktop/getTimeRestrictions', { desktopId: desktop.id })).data
        desktop.playListTree.PlayListItem_DateRestrictions = timeRestrictions.dateRestrictions
        desktop.playListTree.PlayListItem_DaytimeRestrictions = timeRestrictions.daytimeRestrictions
        desktop.name = this.getFullDeviceNameByDesktopId(desktop.id)
      }
      this.desktops = this.desktops.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      this.isLoading = false
    },
    async populateDesktop (deviceDesktop) {
      let path = `DeviceDesktop/${deviceDesktop.id}`
      const populatedDesktop = await Vue.axios.get(path).then(response => { return response.data })
      return populatedDesktop
    },
    getScreenShotStyle (desktop) {
      let width = (this.containerWidth - this.deviceDesktops.length * 10) / this.deviceDesktops.length
      let height = desktop.height / desktop.width * width
      if (height > 160) {
        height = 160
        width = height * desktop.width / desktop.height
      }
      const playlistThumbURI = this.playListThumbnailById(desktop.LocalPlayList.id)
      return `
        background-image: url('${playlistThumbURI}');
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        width: ${width}px;
        height: ${height}px;
      `
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.name-input {
  width: 80%;
  margin-right: 10px;
}
.desktop-name {
  color: $--color-warning;
}
.desktops {
  display: flex;
  justify-content: center;
  .desktop {
    border-right: $--border-light;
    padding: 0px 5px;
    display: flex;
    flex-direction: column;
    align-items: left;
    .name {
      color: $--color-text-primary;
      font-size: $--font-size-base;
      text-align: center;
      margin-bottom: 10px;
    }
    .screenshot {
      min-height: 300px;
      display: flex;
      align-items: center;
      img {
        border: 1px solid $--color-primary;
      }
    }
  }
}
.group-name {
  color: $--color-warning;
}
.top-row {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  .day-of-week {
    width: 100px;
  }
}
.progres-container {
  height: 20px;
  width: 20px;
  margin-left: 10px;
  border-radius: 10px;
  background-color: $--color-primary;
  .progres {
    border-radius: 10px;
    animation: pulse 1s infinite;
    width: 20px;
    height: 20px;
    background-color: rgba($--color-danger, 0.5);
    animation-timing-function: ease-out;
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.0)
  }
  100% {
    transform: scale(1.0)
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/GroupView.vue